import React, { useState } from 'react'
import ControlledModal from './ControlledModal'
import { Button } from '../ui/button'
import { useRegisterCreatorMutation } from '../../reactWrapper/Redux/apiSlice'
import { toast } from 'react-toastify'

const RegisterCreator = ({ close }) => {
  const [form, setForm] = useState({
    first_name: '',
    last_name: '',
    email: '',
    phone_no: ''
  })

  const [registerCreator, { isLoading }] = useRegisterCreatorMutation()

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    
    if (!form.first_name.trim() || !form.last_name.trim() || !form.email.trim()) {
      toast.error('First Name, Last Name, and Email are required')
      return
    }

    try {
      const payload = {
        first_name: form.first_name.trim(),
        last_name: form.last_name.trim(),
        email: form.email.trim().toLowerCase(),
        phone_no: form.phone_no.trim()
      }

      const response = await registerCreator(payload).unwrap()
      if (response && response.status) {
        toast.success(response.message || 'Creator registered successfully!')
        close()
      } else {
        toast.error(response?.message || 'Failed to register creator')
      }
    } catch (error) {
      console.error('Registration error:', error)
      toast.error(error?.data?.message || error?.message || 'An error occurred during registration')
    }
  }

  return (
    <ControlledModal
      open={true}
      closeModal={close}
      contentStyle={{ width: '480px', borderRadius: '12px', padding: '0px' }}
    >
      <div className="bg-white rounded-lg p-6 flex flex-col gap-6 shadow-xl">
        <div className="flex justify-between items-center border-b pb-3 border-gray-100">
          <h2 className="font-display text-xl font-bold text-gray-800">Register Content Creator</h2>
          <button 
            onClick={close} 
            className="text-gray-400 hover:text-gray-600 transition text-lg font-semibold"
          >
            &times;
          </button>
        </div>

        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <div className="flex flex-col gap-1">
            <label className="text-xs font-semibold text-gray-600 uppercase tracking-wider">
              First Name <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              name="first_name"
              value={form.first_name}
              onChange={handleChange}
              placeholder="Enter first name"
              className="border border-gray-300 rounded-md px-3 py-2 text-sm focus:border-brand-orange focus:outline-none transition-colors w-full"
              required
            />
          </div>

          <div className="flex flex-col gap-1">
            <label className="text-xs font-semibold text-gray-600 uppercase tracking-wider">
              Last Name <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              name="last_name"
              value={form.last_name}
              onChange={handleChange}
              placeholder="Enter last name"
              className="border border-gray-300 rounded-md px-3 py-2 text-sm focus:border-brand-orange focus:outline-none transition-colors w-full"
              required
            />
          </div>

          <div className="flex flex-col gap-1">
            <label className="text-xs font-semibold text-gray-600 uppercase tracking-wider">
              Email Address <span className="text-red-500">*</span>
            </label>
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              placeholder="Enter email address"
              className="border border-gray-300 rounded-md px-3 py-2 text-sm focus:border-brand-orange focus:outline-none transition-colors w-full"
              required
            />
          </div>

          <div className="flex flex-col gap-1">
            <label className="text-xs font-semibold text-gray-600 uppercase tracking-wider">
              Phone Number
            </label>
            <input
              type="tel"
              name="phone_no"
              value={form.phone_no}
              onChange={handleChange}
              placeholder="Enter phone number"
              className="border border-gray-300 rounded-md px-3 py-2 text-sm focus:border-brand-orange focus:outline-none transition-colors w-full"
            />
          </div>

          <div className="flex items-center justify-end gap-3 mt-4 border-t pt-4 border-gray-100">
            <Button
              type="button"
              onClick={close}
              className="text-sm rounded-md border border-border py-1.5 px-4 text-muted-foreground bg-white hover:bg-gray-50 transition"
            >
              Cancel
            </Button>
            <Button
              type="submit"
              disabled={isLoading}
              className="text-sm rounded-sm text-white bg-brand-navy  py-1.5 px-5 transition disabled:opacity-60"
            >
              {isLoading ? 'Registering...' : 'Register'}
            </Button>
          </div>
        </form>
      </div>
    </ControlledModal>
  )
}

export default RegisterCreator